import './Checkout.css';
import React, { useEffect } from 'react';
import { ICheckoutState } from '../../store/CheckoutContext';
import { Checkbox, FormControlLabel, Grid, Typography } from '@material-ui/core';
import { GenerateFields } from '../../components/checkout/CheckoutInput';

interface Props {
  state: ICheckoutState;
  setState: React.Dispatch<React.SetStateAction<{ [key: string]: any }>>;
}

const StepSecond: React.FC<Props> = props => {
  const { state, setState } = props;

  return (
    <div className="CheckoutIframe">
      <Grid item>
        <div className="">
          <Typography variant="h6" gutterBottom>
            Billing address
          </Typography>
          <GenerateFields state={state} setState={setState} fieldName={'address'} />
        </div>
      </Grid>
    </div>
  );
};

export default StepSecond;
